import {z} from 'zod';

import {optionalText} from './catalogueUi';
import {optionalMoneyInput, priceInput} from './moneyInput';

export const packageSchema = z.object({
  name: z.string().trim().min(1),
  factoryCode: optionalText,
  description: z.string().trim().min(1),
  status: z.enum(['draft', 'active']),
  priceNet: priceInput,
  costNet: optionalMoneyInput,
  memberFeatureIds: z.array(z.string()),
  applicableTrimIds: z.array(z.string()),
  // Library taxonomy edited in place: members listed here are sold only inside packages.
  packageOnlyFeatureIds: z.array(z.string()),
});
